function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["match", "Component", "isComponentResolved", "hasComponent", "element", "routeChildren", "querySubscription", "fetched"];

/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { ReactRelayContext } from 'react-relay';
import renderElement from './renderElement';
var hasOwnProperty = Object.prototype.hasOwnProperty;
var ReadyStateRenderer = /*#__PURE__*/function (_React$Component) {
  function ReadyStateRenderer(props) {
    var _this2;
    _classCallCheck(this, ReadyStateRenderer);
    _this2 = _callSuper(this, ReadyStateRenderer, [props]);
    _this2.onUpdate = function () {
      if (!_this2.props.fetched) {
        // Ignore subscription updates if our data aren't yet fetched. We'll
        // rerender anyway once fetching finishes.
        return;
      }
      var _this2$props = _this2.props,
        match = _this2$props.match,
        Component = _this2$props.Component,
        isComponentResolved = _this2$props.isComponentResolved,
        hasComponent = _this2$props.hasComponent,
        querySubscription = _this2$props.querySubscription;
      var element = renderElement({
        match: match,
        Component: Component,
        isComponentResolved: isComponentResolved,
        hasComponent: hasComponent,
        querySubscription: querySubscription,
        resolving: false
      });
      _this2.setState({
        element: element || null
      });
    };
    var _element = props.element,
      _querySubscription = props.querySubscription;
    _this2.state = {
      isInitialRender: true,
      element: _element,
      propsElement: _element,
      querySubscription: _querySubscription,
      selectionReference: _querySubscription.retain(),
      onUpdate: _this2.onUpdate
    };
    return _this2;
  }
  _inherits(ReadyStateRenderer, _React$Component);
  return _createClass(ReadyStateRenderer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.querySubscription.subscribe(this.onUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.state.selectionReference.dispose();
      this.props.querySubscription.unsubscribe(this.onUpdate);
    }
  }, {
    key: "render",
    value: function render() {
      var element = this.state.element;
      if (!element) {
        return element;
      }
      var _this$props = this.props,
        routeChildren = _this$props.routeChildren,
        querySubscription = _this$props.querySubscription,
        ownProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
      var relayProps = querySubscription.readyState.props;
      if (relayProps) {
        Object.keys(relayProps).forEach(function (relayPropName) {
          // At least on Node v8.x, it's slightly faster to guard the delete here
          // with this hasOwnProperty check.
          if (hasOwnProperty.call(ownProps, relayPropName)) {
            if (process.env.NODE_ENV !== 'production') {
              console.error("Ignoring <ReadyStateRenderer> prop `".concat(relayPropName, "` that shadows a Relay prop from its query `").concat(querySubscription.getQueryName(), "`. This is most likely due to its parent cloning it and adding extraneous Relay props."));
            } // @ts-ignore

            delete ownProps[relayPropName];
          }
        });
      }
      return /*#__PURE__*/React.createElement(ReactRelayContext.Provider, {
        value: querySubscription.relayContext
      }, typeof element === 'function' ? /*#__PURE__*/React.cloneElement(element(routeChildren), ownProps) : /*#__PURE__*/React.cloneElement(element, Object.assign({}, /*#__PURE__*/React.isValidElement(routeChildren) ? {
        children: routeChildren
      } : routeChildren, ownProps)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, state) {
      var element = _ref.element,
        querySubscription = _ref.querySubscription;
      if (state.isInitialRender) {
        return {
          isInitialRender: false
        };
      }
      var nextState = null;
      if (element !== state.propsElement) {
        nextState = {
          element: element,
          propsElement: element
        };
      }
      if (querySubscription !== state.querySubscription) {
        state.selectionReference.dispose();
        state.querySubscription.unsubscribe(state.onUpdate);
        nextState = nextState || {};
        nextState.querySubscription = querySubscription;
        nextState.selectionReference = querySubscription.retain();
        querySubscription.subscribe(state.onUpdate);
      }
      return nextState;
    }
  }]);
}(React.Component);
export default ReadyStateRenderer;